module.exports = require("./kk.js");